import { render } from "./2.AllServices.vue?vue&type=template&id=04fb13b0&scoped=true"
import script from "./2.AllServices.vue?vue&type=script&lang=js"
export * from "./2.AllServices.vue?vue&type=script&lang=js"

import "./2.AllServices.vue?vue&type=style&index=0&id=04fb13b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fb13b0"]])

export default __exports__